<template>
  <header class="school-header">

    <div class="header-top">
      <!-- 顶部导航栏 -->
      <div class="top-nav">
        <div class="top-nav-container">
          <div class="top-nav-left">
            <a class="top-nav-link" @click="topGo(14,1402,'访客身份','教工')">教工</a>
            <a class="top-nav-link" @click="topGo(14,1401,'访客身份','学生')">学生</a>
            <a class="top-nav-link" @click="topGo(14,1403,'访客身份','校友')">校友</a>
            <a class="top-nav-link" @click="topGo(14,1404,'访客身份','访客')">访客</a>
            <a class="top-nav-link" @click="topGoNav(26)">新闻动态</a>
            <a class="top-nav-link" @click="topGo(12,1201,'通知公告','校园公告')">通知公告</a>
            <a class="top-nav-link" >互动交流</a>

          </div>
          <div class="top-nav-right">
            <a  class="top-nav-link"  @click="topGoNav(19)">一中VI系统</a>
            <a  class="top-nav-link"  @click="topGoNav(22)">公共服务</a>
            <a  class="top-nav-link"  @click="topGoNav(25)">校历周历</a>
            <a  class="top-nav-link"  @click="topGoNav(24)">信息公开</a>
            <a  class="top-nav-link" @click="topGo(13,1301,'校园媒体','电子校报')">校园媒体</a>
            <a  class="top-nav-link"  @click="topGoNav(23)">下载中心</a>
            <a  class="top-nav-link"  @click="topGoNav(23)">校园云盘</a>
            <div class="search-box" @click="goSearch">
              <button class="search-btn">🔍</button>
              <p>搜索</p>

            </div>
          </div>
        </div>
      </div>

      <!-- 主视觉区域 -->
      <div class="hero-section">
        <div class="hero-container">
          <div class="school-logo">
            <img src="@/assets/img/logo.png" alt="">
          </div>
        </div>
      </div>
    </div>
    <!-- 主导航栏 -->
    <nav class="main-nav">
      <div class="nav-container">
        <ul class="nav-list">

          <li class="nav-item" v-for="nav in NavList" :key="nav.id" @mouseenter="navMouseenter(nav)" @mouseleave="navMouseleave">
            <template v-if="nav.isShow">
              <router-link to="/" class="nav-link" v-if="nav.id == 1" @click.native="onTopNavClick()">{{ nav.title }}</router-link>
              <router-link :to="'/category?id='+nav.id" class="nav-link" v-else  @click.native="onTopNavClick(nav)">{{ nav.title }}</router-link>
            </template>
          </li>

        </ul>
      </div>
      <transition name="dropdown" @enter="onEnter" @leave="onLeave">
        <div class="content-container" :class="{ 'dropdown-active': secondList.length > 0 }" v-if="secondList.length > 0" @mouseenter="onContentEnter" @mouseleave="onContentLeave">
          <div class="content-center">


            <ul class="sub-nav-list">
              <li class="sub-nav-item" v-for="subNav in secondList" :key="subNav.id" @mouseenter="updateCurrentNav">
                <a href="#" class="sub-nav-link" @click="goToSubNav(subNav)">{{ subNav.title }}</a>
              </li>
            </ul>
            <div class="content-area">
              <div class="content-placeholder">
                <p class="desc-tu"><img src="/admin-api/infra/file/4/get/45c6d5a2c46743927c0ada58f8eaaf316b8350a10b06b12e1ac822a4b086893e.jpg" alt=""></p>
                <p>{{ currentNavObj.description }}</p>
              </div>

            </div>
            <div class="picshow">
              <img :src="currentNavObj.showPic + '?t=' + (currentNavObj._updateTime || '')" alt="">
              <!-- <img src="@/assets/img/header-bg.png" alt=""> -->
            </div>
          </div>
        </div>
      </transition>
    </nav>
  </header>
</template>

<script>
import { homeApi } from '@/api/index';
//import{NavList} from '@/api/nav'

export default {
  name: 'SchoolHeader',
  data(){
    return{
      NavList: [],
      navId:2,
      secondList:[],
      hideTimer: null,
      currentNavObj:{},
      isNavigating: false // 添加导航状态标记
    }
  },
  mounted(){
    // 组件挂载后获取导航数据
    let localStorageNavList = JSON.parse(sessionStorage.getItem('navList')) ;
    console.log('localStorageNavList',localStorageNavList)
    if(localStorageNavList && localStorageNavList.length > 0){
      this.NavList = localStorageNavList;
    }else{
      this.getNavList()
    }

    // 检查是否来自路由跳转，如果是则保持 isNavigating 状态
    try {
      if (document.body.classList.contains('navigating')) {
        this.isNavigating = true
      }
    } catch (e) { void e }

    // 监听路由完成，重置导航状态
    this.$watch('$route', () => {
      this.isNavigating = false
    })
  },
  beforeDestroy() {
    // 清理定时器和状态
    if (this.hideTimer) {
      clearTimeout(this.hideTimer);
      this.hideTimer = null;
    }
    this.isNavigating = false;
    // 显示轮播图按钮
    this.showCarouselButtons();
  },
  computed: {
    // 当前导航标题
    currentNavTitle() {
      if (this.navId && this.NavList.length > 0) {
        const currentNav = this.NavList.find(nav => nav.id === this.navId)
        return currentNav ? currentNav.title : '学校概况'
      }
      return '学校概况'
    },

  },
  methods:{
    updateCurrentNav() {
      this.navUpdateTimestamp = Date.now();
      this.currentNavObj = {
        ...this.currentNavObj,
        timestamp: this.navUpdateTimestamp // 添加时间戳到对象
      };
    },
    onTopNavClick() {
      // 顶部导航点击：立即隐藏下拉

      this.secondList = []
      this.currentNavObj = {}
      this.navId = null
      this.isNavigating = true
      this.showCarouselButtons()

    },
    //获取导航列表数据
    async getNavList(){
      try {
        let params = {}

        const response = await homeApi.getNavList(params)
        console.log('response',response)
        if (response &&  response.code === 0) {
          // 处理返回的导航数据
          const navData = response.data || []

          // 如果有数据，更新 NavList
          if (navData.length > 0) {
            this.NavList = navData;

            sessionStorage.setItem('navList',JSON.stringify(navData) )

            console.log('导航数据加载成功:', this.NavList)
          } else {
            console.log('没有获取到导航数据，使用默认数据')
          }
        } else {
          console.error('获取导航数据失败:', response)
        }
      } catch (error) {
        console.error('获取导航数据异常:', error)
        // 如果接口调用失败，继续使用默认的 NavList 数据
        console.log('使用默认导航数据')
      }
    },
    async navMouseenter(nav) {
      // 如果正在导航跳转，重置状态但不显示，等待下次移入
      if (this.isNavigating) {
        console.log('跳转后首次移入，重置状态但不显示')
        this.isNavigating = false
        return
      }

      // 鼠标移入时显示子菜单
      // 先清除之前的隐藏定时器
      if (this.hideTimer) {
        clearTimeout(this.hideTimer);
        this.hideTimer = null;
      }

      this.navId = nav.id;
      const navIndex = this.NavList.findIndex(item => item.id === nav.id);
      this.currentNavObj = this.NavList[navIndex];
      if (navIndex !== -1) {

        this.secondList = this.NavList[navIndex].children
        // 隐藏轮播图按钮
        this.hideCarouselButtons();
      }

    },
    navMouseleave() {
      // 鼠标移出时延迟隐藏子菜单
      this.hideTimer = setTimeout(() => {
        this.secondList = [];
        this.currentNavObj = {};
        // 显示轮播图按钮
        this.showCarouselButtons();
        this.navId = null;
        console.log('延迟隐藏子菜单');
      }, 300); // 300ms延迟
    },
    onEnter(el) {
      // 进入动画
      el.style.height = '0';
      el.style.opacity = '0';
      el.offsetHeight; // 强制重排
      el.style.transition = 'height 0.3s ease, opacity 0.3s ease';
      el.style.height = el.scrollHeight + 'px';
      el.style.opacity = '1';
    },
    onLeave(el) {
      // 离开动画
      el.style.transition = 'height 0.3s ease, opacity 0.3s ease';
      el.style.height = '0';
      el.style.opacity = '0';
    },
    onContentEnter() {
      // 如果正在导航跳转，重置状态但不显示，等待下次移入
      if (this.isNavigating) {
        console.log('跳转后首次移入内容区域，重置状态但不显示')
        this.isNavigating = false
        return
      }

      // 鼠标移入内容区域时，取消隐藏定时器
      if (this.hideTimer) {
        clearTimeout(this.hideTimer);
        this.hideTimer = null;
      }
      // 隐藏轮播图按钮
      this.hideCarouselButtons();
      console.log('鼠标移入内容区域，取消隐藏定时器');
    },
    onContentLeave() {
      // 鼠标移出内容区域时，延迟隐藏子菜单
      this.hideTimer = setTimeout(() => {
        this.secondList = [];
        this.navId = null;
        // 显示轮播图按钮
        this.showCarouselButtons();
        console.log('延迟隐藏子菜单');
      }, 300); // 300ms延迟
    },
    // 跳转到子导航页面
    goToSubNav(subNav) {
      // 阻止默认行为
      event.preventDefault()
      console.log('subNav',this.currentNavObj,subNav)

      // 设置导航状态，防止下拉菜单重新显示
      this.isNavigating = true;

      // 隐藏子菜单
      this.secondList = []
      this.navId = null

      // 否则跳转到分类页面，传递子导航信息
      this.$router.push({
        path: '/categoryMore',
        query: {

          categoryId:this.currentNavObj.id,
          sectionId:subNav.id,
          categoryTitle: this.currentNavObj.title,
          sectionTitle: subNav.title

        }
      }).then(() => {
        // 路由跳转完成后，延迟重置导航状态
        setTimeout(() => {
          this.isNavigating = false;
        }, 500); // 500ms后重置状态
      }).catch(() => {
        // 如果跳转失败，立即重置状态
        this.isNavigating = false;
      });


      console.log('跳转到子导航:', subNav)
    },
    // 隐藏轮播图按钮
    hideCarouselButtons() {
      document.body.classList.add('dropdown-menu-active');
      console.log('通过hideCarouselButtons添加dropdown-menu-active类');
    },
    // 显示轮播图按钮
    showCarouselButtons() {
      document.body.classList.remove('dropdown-menu-active');
      console.log('通过showCarouselButtons移除dropdown-menu-active类');
    },

    goSearch(){
      this.$router.push({
        path: '/search',
      })

    },
    //最上面小字导航的跳转到二级导航
    topGo(id,subId,title,subTitle){

      if(this.$route.query.sectionId == subId) return;
      this.$router.push({
        path: '/categoryMore',
        query: {

          categoryId:id,
          sectionId:subId,
          categoryTitle:title,
          sectionTitle: subTitle

        }
      })
    },
    //最上面小字导航的跳转到一级导航
    topGoNav(id){
      if(this.$route.query.id == id) return;
      this.$router.push({
        path: '/category',
        query: {
          id:id

        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
@import '../assets/styles/variables.less';
@import '../assets/styles/mixins.less';

.school-header {
  position: relative;
  z-index: 10;
  background: transparent;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}

.header-top{
  background: url('~@/assets/img/header-bg.png') no-repeat center top;
  background-size: cover;
  min-height: 144px;
  position: relative;
}

/* 顶部导航栏 */
.top-nav {
  background: #dcdeec;
  opacity: 0.7;
  border-bottom: 1px solid #e9ecef;
  padding: 8px 0;
  position: relative;
  z-index: 2;
}

.top-nav-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.top-nav-left,
.top-nav-right {
  display: flex;
  align-items: center;
  gap: 20px;
  cursor: pointer;
}

.top-nav-link {
  color: #666;
  text-decoration: none;
  font-size: 12px;
  padding: 2px 2px;
  border-radius: 4px;
  transition: all 0.3s ease;

}

.search-box {
  display: flex;
  align-items: center;
  cursor: pointer;
}



.search-btn {
  background: none;
  border: none;
  cursor: pointer;
  font-size: 12px;

  color: #666;

}

/* 主视觉区域 */
.hero-section {
  background: transparent;
  //  padding: 40px 0;
  position: relative;
  z-index: 1;
}

.hero-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  z-index: 1;
}

.school-logo {
  padding-top: 10px;
  img{
    width: 372px;
    height: auto;
  }
}

.logo-badge {
  text-align: center;
}

.logo-circle {
  width: 80px;
  height: 80px;
  background: linear-gradient(135deg, #1e3c72 0%, #2a5298 100%);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 10px;
  box-shadow: 0 4px 15px rgba(30, 60, 114, 0.3);
}

.logo-text {
  color: #fff;
  font-size: 36px;
  font-weight: bold;
  font-family: 'Microsoft YaHei', sans-serif;
}

.logo-text-en {
  color: #1e3c72;
  font-size: 12px;
  font-weight: 600;
  margin-bottom: 4px;
  letter-spacing: 1px;
}

.logo-text-cn {
  color: #666;
  font-size: 11px;
  margin: 0;
}

.school-title {
  text-align: left;
}

.school-name {
  color: #1e3c72;
  font-size: 48px;
  font-weight: bold;
  margin: 0 0 10px 0;
  letter-spacing: 2px;
  font-family: 'Microsoft YaHei', sans-serif;
}

.school-name-en {
  color: #666;
  font-size: 18px;
  margin: 0;
  letter-spacing: 1px;
  font-weight: 500;
}

/* 主导航栏 */
.main-nav {
  background: #1d2088;
  padding: 0;
  position: relative;
  z-index: 1000;
}

.nav-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

.nav-list {
  display: flex;
  align-items: center;
  justify-content: center;
  list-style: none;
  margin: 0;
  padding: 0;
  gap: 0;
}

.nav-item {
  position: relative;
}

.nav-link {
  display: flex;
  align-items: center;
  gap: 6px;
  color: #fff;
  text-decoration: none;
  padding: 15px 20px;
  font-size: 16px;
  font-weight: 500;
  transition: all 0.3s ease;
  white-space: nowrap;
  border-radius: 0;

  &:hover {
    background-color: rgba(255, 255, 255, 0.15);
    transform: translateY(-1px);
  }


}

.nav-icon {
  font-size: 16px;
  margin-right: 4px;
}

/* 子菜单样式 */
.content-container {
  position: absolute;
  top: 100%;
  left: 50%;
  transform: translateX(-50%);
  width: 100%;
  max-width: 100%;
  background: #fff;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  z-index: 9999;
  pointer-events: auto;
  border-top: 3px solid #1d2088;
  overflow: hidden;
  min-height: 300px;


  .content-center{
    width: 1200px;
    margin:30px auto;
    display: flex;

  }
}

/* 路由切换进行中时，强制隐藏下拉容器，避免新页面初始显示 */
body.navigating .content-container {
  display: none !important;
}

/* 过渡动画 */
.dropdown-enter-active,
.dropdown-leave-active {
  transition: all 0.3s ease;
}

.dropdown-enter-from {
  opacity: 0;
  transform: translateX(-50%) translateY(-10px);
}

.dropdown-leave-to {
  opacity: 0;
  transform: translateX(-50%) translateY(-10px);
}

.sub-nav-list {
  display: grid;
  grid-template-rows: repeat(6, min-content);
  grid-auto-flow: column;
  grid-auto-columns: 1fr;
  list-style: none;
  margin: 0;
  padding: 3px 20px;
  width: auto;
  background: #f8f9fa;
  border-right: 1px solid #e9ecef;
  gap: 0px;
  row-gap: 0px;
}

.sub-nav-item {
  /* margin-bottom 已由 grid gap 处理 */
  display: block;
  width:140px;
}

.sub-nav-link {
  display: block;
  color: #333;
  text-decoration: none;
  padding: 8px 4px;
  font-size: 14px;
  font-weight: 400;
  line-height: 1.2;
  transition: all 0.3s ease;
  border-radius: 1px;
  position: relative;

  &:hover {

    color: #1d2088;

  }

  &:before {
    content: "•";
    color: #1d2088;
    margin-right: 8px;
    font-weight: bold;
  }
}

/* 右侧内容区域 */
.content-area {
  //  flex: 1;
  padding:0 30px;
  background: #fff;
}

.content-placeholder {
  width: 260px;
  .desc-tu{
    width: 260px;
    height: auto;
    img{
      display: block;
      width: 100%;
      height: auto;
    }
  }
  p {
    color: #333;
    font-size: 14px;
    line-height: 1.8;
    margin-top:4px ;
    text-align: justify;
  }
}
.picshow{
  width: 400px;
  img{
    display: block;
    width: 100%;
    height: auto;
  }
}

/* 响应式设计 */
@media (max-width: 768px) {
  .top-nav-left,
  .top-nav-right {
    gap: 10px;
  }

  .top-nav-link {
    font-size: 12px;
    padding: 2px 4px;
  }

  .search-input {
    width: 80px;
  }

  .hero-container {
    flex-direction: column;
    text-align: center;
  }

  .school-logo {
    margin-right: 0;
    margin-bottom: 20px;
  }

  .school-name {
    font-size: 36px;
  }

  .nav-list {
    flex-wrap: wrap;
    justify-content: center;
  }

  .nav-link {
    padding: 12px 15px;
    font-size: 14px;
  }
}

/* 隐藏轮播图按钮的CSS类 */
.hide-carousel-button {
  display: none !important;
}

/* 当下拉菜单激活时，隐藏轮播图按钮 */
.dropdown-menu-active .school-banner .swiper-button-next,
.dropdown-menu-active .school-banner .swiper-button-prev {
  display: none !important;
  visibility: hidden !important;
  opacity: 0 !important;
  pointer-events: none !important;
}

</style>
